import React from 'react';
import { userManagementRoute } from '@/modules/administration/user-management/routes';
import { createRoute } from '@tanstack/react-router';

export const groupsRoute = createRoute({
  getParentRoute: () => userManagementRoute,
  path: 'groups',
  wrapInSuspense: true,
  component: React.lazy(async () => await import('@/app/routes/Admin/Users/UserGroupList')),
});
